<template>
  <svg role="presentation" class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="cls-1" d="M18.3332 14.1V16.6C18.3341 16.8321 18.2866 17.0618 18.1936 17.2745C18.1006 17.4871 17.9643 17.678 17.7933 17.8349C17.6222 17.9918 17.4203 18.1112 17.2005 18.1856C16.9806 18.26 16.7477 18.2876 16.5165 18.2667C13.9522 17.988 11.489 17.1118 9.32486 15.7083C7.31139 14.4289 5.60431 12.7218 4.32486 10.7083C2.91651 8.53435 2.04007 6.05917 1.76653 3.48334C1.7457 3.2529 1.77309 3.02064 1.84695 2.80136C1.9208 2.58208 2.03951 2.38058 2.1955 2.20969C2.3515 2.0388 2.54137 1.90227 2.75302 1.80878C2.96468 1.71529 3.19348 1.66689 3.42486 1.66668H5.92486C6.32928 1.6627 6.72136 1.80591 7.028 2.06962C7.33464 2.33333 7.53493 2.69955 7.59153 3.10001C7.69705 3.90006 7.89274 4.68562 8.17486 5.44168C8.28698 5.73995 8.31125 6.0641 8.24478 6.37574C8.17832 6.68738 8.02392 6.97344 7.79986 7.20001L6.74153 8.25834C7.92783 10.3446 9.65524 12.072 11.7415 13.2583L12.7999 12.2C13.0264 11.976 13.3125 11.8216 13.6241 11.7551C13.9358 11.6886 14.2599 11.7129 14.5582 11.825C15.3143 12.1071 16.0998 12.3028 16.8999 12.4083C17.3047 12.4655 17.6744 12.6693 17.9386 12.9813C18.2029 13.2932 18.3433 13.6913 18.3332 14.1Z" />
  </svg>
</template>

<script>
export default {
  name: 'ContactPhoneIcon'
}
</script>

<style lang="scss" scoped>
.icon {
  height: 2rem;
  width: 2rem;
}

.cls-1 {
  fill: none;
  stroke: var(--_zenith-header-text-link, var(--zenith-header-text-link));
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
